import * as R from 'ramda';
import React, { useState, useEffect } from 'react';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const endpointsByType = {
  driver: endpointsMap.driverPayrollStatuses,
  carrier: endpointsMap.carrierInvoiceStatuses,
  customer: endpointsMap.customerInvoiceStatuses,
  fleetService: endpointsMap.fleetServiceInvoiceStatuses,
};

const statusConfigKeys = {
  driver: 'DPStatusConfig',
  customer: 'CIStatusConfig',
  carrier: 'CarrierIStatusConfig',
  fleetService: 'FleetServiceIStatusConfig',
};

export const withAsyncInvoiceStatusConfigs = (Component) => (props) => {
  const { branchGuid, invoiceStatusConfigType } = props;

  const type = R.propOr(invoiceStatusConfigType, GC.FIELD_TYPE, props);

  const [statusConfigs, setStatusConfigs] = useState({
    CIStatusConfig: null,
    DPStatusConfig: null,
    CarrierIStatusConfig: null,
    FleetServiceIStatusConfig: null,
  });

  useEffect(() => {
    const handleGetStatusConfigRequest = async (statusType) => {
      if (G.isNilOrEmpty(branchGuid)) return;

      try {
        const endpoint = R.prop(statusType, endpointsByType);
        const options = { params: { [GC.FIELD_BRANCH_GUID]: branchGuid } };

        const res = await sendRequest('get', endpoint, options);

        const { data, status } = res;

        if (G.isResponseSuccess(status)) {
          const configKey = R.prop(statusType, statusConfigKeys);

          setStatusConfigs((prev) => ({
            ...prev,
            [configKey]: data,
          }));
        } else {
          G.handleFailResponseSimple(res, true, 'withAsyncInvoiceStatusConfigs');
        }
      } catch (err) {
        G.handleException('error', 'withAsyncInvoiceStatusConfigs exception');
      }
    };

    const handleGetConfigs = async () => {
      if (R.includes(type, ['driver', 'customer', 'carrier', 'fleetService'])) {
        handleGetStatusConfigRequest(type);
      } else {
        await Promise.all([
          handleGetStatusConfigRequest('driver'),
          handleGetStatusConfigRequest('carrier'),
          handleGetStatusConfigRequest('customer'),
        ]);
      }
    };

    handleGetConfigs();
  }, []);

  return <Component {...props} {...statusConfigs} />;
};
